import script from "./SaddleFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaddleFilters.vue?vue&type=script&setup=true&lang=ts"

import "./SaddleFilters.vue?vue&type=style&index=0&id=7e1e7713&lang=scss"

const __exports__ = script;

export default __exports__